import { Component, Inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { IconComponent } from '../../../../../../shared/components/ui/icon/icon.component';
import { LoaderButtonComponent } from '../../../../../../shared/components/loader-button/loader-button/loader-button.component';
import { ModalComponent } from '../../../../../../shared/components/modals/modal/modal.component';
import { SafePipe } from 'safe-pipe';
import { TranslatePipe } from '../../../../../../shared/pipes/translate/translate.pipe';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { formsActions } from '../../../../../../store/features/forms/forms-actions';
import {
  CollectionListDataInstance
} from '../../../../../../shared/interfaces/collection-list-data-instance';
import { Store } from '@ngrx/store';

@Component({
  selector: 'bizz-instance-already-linked',
  standalone: true,
  imports: [
    AsyncPipe,
    IconComponent,
    LoaderButtonComponent,
    ModalComponent,
    SafePipe,
    TranslatePipe
  ],
  templateUrl: './instance-already-linked.component.html',
  styleUrl: './instance-already-linked.component.scss'
})
export class InstanceAlreadyLinkedComponent {
  public  displayProperties : Array<any>;

  public constructor(private store$: Store,public dialogRef: DialogRef, @Inject(DIALOG_DATA) public data: {
    instance: CollectionListDataInstance,
    formId: string,
    gridFieldId: number
  }) {
    this.displayProperties = [];
    for (const property in this.data.instance) {
      if (Object.prototype.hasOwnProperty.call(this.data.instance, property) && property.indexOf('F_') == 0) {
        this.displayProperties.push(this.data.instance[property]);
      }
    }
  }


  public link(): void {
    this.store$.dispatch(formsActions.addInstancesToGrid({ formId: this.data.formId, gridFieldId: this.data.gridFieldId, instances: [{...this.data.instance, LinkedToParentVersions: undefined}] }));
    this.dialogRef.close(true);
  }

}
